/* Dr.Kalla storefront chat widget.
   Renders the floating launcher + chat panel, streams answers from the app-proxy
   endpoint (/apps/drkalla-profi/chat) over SSE, shows product cards and handles
   add-to-cart. Config comes from window.DKChatConfig (set in the Liquid snippet). */
(function () {
  "use strict";

  var cfg = window.DKChatConfig || {};
  var ENDPOINT = cfg.endpoint || "/apps/drkalla-profi/chat";
  var NEWSLETTER_URL = cfg.newsletterUrl || "/apps/drkalla-profi/newsletter";
  var CART_ADD = cfg.cartAddUrl || "/cart/add.js";
  var CART_URL = cfg.cartUrl || "/cart";
  var STORAGE_KEY = "dkChatCompanion.v2";
  var SESSION_TTL = 2 * 60 * 60 * 1000;
  var MAX_MSG_LEN = 4000;
  // Conversion config (see drkalla-chat-widget.liquid).
  var FREE_SHIP = Number(cfg.freeShipThreshold) || 0; // in cents; 0 disables the bar
  var CURRENCY = cfg.currencySymbol || "€";
  var WELCOME_PCT = Number(cfg.welcomePercent) || 10;
  var SUGGESTIONS = cfg.suggestions || [
    "Welches Shampoo bei coloriertem Haar?",
    "Habt ihr Blondierung?",
    "Wie sind Versand & Lieferzeit?",
  ];

  var root, body, input, sendBtn, launcher, panel;
  var shipWrap, shipTxt, shipFill;
  var session = loadSession();
  var messages = session.messages || [];
  var contextEnabled = session.contextEnabled !== false;
  var contextLabel, contextToggle;
  var streaming = false;
  var currentBubble = null;
  var statusEl = null;
  var greeted = false;
  var currentAbort = null;

  // --- utils ---------------------------------------------------------------
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function safeLink(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      var url = new URL(String(value || '').replace(/&amp;/g, '&'), window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      var path = url.pathname;
      if (!/^(?:\/$|\/products\/[a-z0-9][a-z0-9-]*\/?$|\/collections(?:\/[a-z0-9][a-z0-9-]*)?\/?$|\/blogs\/news(?:\/[a-z0-9][a-z0-9-]*)?\/?$|\/pages\/(?:profi|konto|contact|uber-uns|startseite)$|\/policies\/(?:shipping-policy|refund-policy|privacy-policy|terms-of-service|legal-notice|contact-information)$|\/(?:cart|search)$)/.test(path)) return null;
      var variant = url.searchParams.get('variant');
      var query = path.indexOf('/products/') === 0 && /^\d{1,24}$/.test(variant || '') ? '?variant=' + variant : '';
      return path + query + (/^#[a-zA-Z0-9_-]{1,80}$/.test(url.hash) ? url.hash : '');
    } catch (e) { return null; }
  }
  function safeImage(value) {
    if (typeof value !== 'string' || !value.trim()) return null;
    try {
      var url = new URL(value, window.location.origin);
      return url.protocol === 'https:' && ['cdn.shopify.com', window.location.hostname].indexOf(url.hostname) >= 0 ? url.href : null;
    } catch(e) { return null; }
  }
  // Escape first (XSS-safe), then apply a small markdown subset: **bold**,
  // [text](url) links, "- "/"* " bullet lists, and newlines.
  function renderText(s) {
    var esc = escapeHtml(stripMarkers(s))
      .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
      .replace(
        /\[([^\]]+)\]\((https?:\/\/[^\s)]+|\/[^\s)]+)\)/g,
        function (_, label, href) {
          var target = safeLink(href);
          return target ? '<a href="' + escapeHtml(target) + '">' + label + '</a>' : label;
        }
      );
    var lines = esc.split("\n");
    var parts = [];
    var textRun = [];
    var listRun = [];
    function flushText() {
      if (textRun.length) {
        parts.push(textRun.join("<br>"));
        textRun = [];
      }
    }
    function flushList() {
      if (listRun.length) {
        parts.push('<ul class="dk-md-list"><li>' + listRun.join("</li><li>") + "</li></ul>");
        listRun = [];
      }
    }
    for (var i = 0; i < lines.length; i++) {
      var m = lines[i].match(/^\s*[-*]\s+(.*)$/);
      if (m) {
        flushText();
        listRun.push(m[1]);
      } else {
        flushList();
        textRun.push(lines[i]);
      }
    }
    flushText();
    flushList();
    return parts.join("");
  }
  function scrollDown() {
    if (body) body.scrollTop = body.scrollHeight;
  }
  function isMobile() {
    return window.matchMedia("(max-width: 600px)").matches;
  }
  function formatMoney(cents) {
    var v = (Number(cents) || 0) / 100;
    try {
      return (
        v.toLocaleString("de-DE", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) +
        " " +
        CURRENCY
      );
    } catch (e) {
      return v.toFixed(2) + " " + CURRENCY;
    }
  }
  function loadSession() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      var saved = raw && raw.length < 150000 ? JSON.parse(raw) : {};
      if (saved.owner !== String(cfg.customerScope || 'guest') || !Number.isFinite(saved.updatedAt) || Date.now() - saved.updatedAt > SESSION_TTL || saved.updatedAt > Date.now() + 60000) return {};
      saved.messages = Array.isArray(saved.messages) ? saved.messages.filter(function(m) { return m && ['user','assistant'].indexOf(m.role) >= 0 && typeof m.content === 'string'; }).slice(-12).map(function(m) {
        return { role:m.role, content:m.content.slice(0,MAX_MSG_LEN), products:references(m.products), links:cleanLinks(m.links), pending:m.pending === true };
      }) : [];
      return saved;
    } catch (e) {
      return {};
    }
  }
  function references(items) {
    return (Array.isArray(items) ? items : []).slice(0,8).filter(function(p) { return p && typeof p.title === 'string' && /^\/products\//.test(safeLink(p.url) || ''); }).map(function(p) {
      return { title:p.title.slice(0,200), url:safeLink(p.url), image:safeImage(p.image), referenceOnly:true };
    });
  }
  function cleanLinks(items) {
    return (Array.isArray(items) ? items : []).slice(0,4).filter(function(p) { return p && typeof p.label === 'string' && safeLink(p.url); }).map(function(p) { return {label:p.label.slice(0,80),url:safeLink(p.url)}; });
  }
  function saveHistory() {
    try {
      var trimmed = messages.slice(-12).map(function (m) {
        return { role: m.role, content: String(m.content || "").slice(0, MAX_MSG_LEN), products:references(m.products), links:cleanLinks(m.links), pending:m.pending === true };
      });
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({updatedAt:Date.now(), owner:String(cfg.customerScope || 'guest'), messages:trimmed, open:!!root && root.classList.contains('dk-open'), contextEnabled:contextEnabled}));
      sessionStorage.removeItem('dkChatHistory.v1');
    } catch (e) {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e2) {
        /* ignore */
      }
    }
  }
  function pageContext() {
    if (!contextEnabled) return null;
    var path = window.location.pathname;
    var product = path.match(/^\/(?:collections\/[a-z0-9-]+\/)?products\/([a-z0-9][a-z0-9-]*)\/?$/);
    if(product) path = '/products/' + product[1];
    if(!safeLink(path)) return null;
    var result = {path:path};
    var variant = new URLSearchParams(window.location.search).get('variant');
    if(product && /^\d{1,24}$/.test(variant || '')) result.variantId = variant;
    return result;
  }
  function updateContext() {
    if(!contextLabel) return;
    var current = pageContext();
    var path = current && current.path;
    contextLabel.textContent = !contextEnabled ? 'Seitenkontext aus' : !path ? 'Kein Seitenkontext auf dieser Seite' : path.indexOf('/products/') === 0 ? 'Aktuelle Produktseite' : path === '/pages/profi' ? 'Profi-Zugang' : path === '/pages/konto' ? 'Anmeldung und Kundenbereich' : path === '/' ? 'Startseite' : 'Aktuelle Shop-Seite';
  }

  // Once-per-session gate for the proactive welcome-voucher offer (anti-spam).
  var OFFER_KEY = "dkOfferShown.v1";
  function offerShown() {
    try {
      return sessionStorage.getItem(OFFER_KEY) === "1";
    } catch (e) {
      return false;
    }
  }
  function markOfferShown() {
    try {
      sessionStorage.setItem(OFFER_KEY, "1");
    } catch (e) {}
  }
  // Eligible = guest, a welcome offer exists, and we haven't offered yet.
  function voucherEligible() {
    return !cfg.customerLoggedIn && WELCOME_PCT > 0 && !offerShown();
  }
  // Strip the agent's control markers from any displayed/stored text.
  function stripMarkers(s) {
    return String(s == null ? "" : s).replace(
      /\[\[(?:GUTSCHEIN|WHATSAPP)\]\]/g,
      ""
    );
  }

  // --- DOM build -----------------------------------------------------------
  function build() {
    root = document.getElementById("dk-chat-root");
    if (!root) {
      root = el("div");
      root.id = "dk-chat-root";
      document.body.appendChild(root);
    }

    launcher = el("button", "dk-chat-launcher");
    launcher.setAttribute("aria-label", "Beratung öffnen");
    launcher.setAttribute("aria-expanded", "false");
    launcher.innerHTML =
      '<svg class="dk-ic dk-ic-chat" viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 6.5h15v9h-9l-4 3.5z"></path><path d="M8.5 10.5h7M8.5 13h4.5"></path></svg>' +
      '<svg class="dk-ic dk-ic-arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"></path></svg>';

    panel = el("div", "dk-chat-panel");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "false");
    panel.setAttribute("aria-label", "Dr.Kalla Berater");
    // Brand the header with the shop logo when available; else a "DK" monogram.
    var headerBrand = cfg.logo
      ? '<div class="dk-chat-header__meta">' +
        '<img class="dk-chat-header__logo" src="' +
        escapeHtml(cfg.logo) +
        '" alt="Dr.Kalla">' +
        '<div class="dk-chat-header__sub">Beratung &amp; Empfehlungen</div>' +
        "</div>"
      : '<div class="dk-chat-header__avatar">DK</div>' +
        '<div class="dk-chat-header__meta">' +
        '<div class="dk-chat-header__title">Dr.Kalla</div>' +
        '<div class="dk-chat-header__sub">Beratung &amp; Empfehlungen</div>' +
        "</div>";
    panel.innerHTML =
      '<div class="dk-chat-header">' +
      headerBrand +
      '<button class="dk-chat-header__close" aria-label="Schließen">&times;</button>' +
      "</div>" +
      '<div class="dk-chat-context"><label><input type="checkbox" id="dk-chat-context" checked> Aktuelle Seite einbeziehen</label><span id="dk-chat-context-label"></span><span class="dk-chat-context__note">Nur der Seitenlink, keine Formulareingaben.</span><button type="button" class="dk-chat-reset">Chat leeren</button></div>' +
      '<div class="dk-ship" id="dk-ship" hidden>' +
      '<div class="dk-ship__txt" id="dk-ship-txt"></div>' +
      '<div class="dk-ship__bar"><span class="dk-ship__fill" id="dk-ship-fill"></span></div>' +
      "</div>" +
      '<div class="dk-chat-body" id="dk-chat-body"></div>' +
      '<div class="dk-chat-foot">' +
      '<form class="dk-chat-form" id="dk-chat-form">' +
      '<textarea class="dk-chat-input" id="dk-chat-input" rows="1" placeholder="Ihre Frage …" autocomplete="off"></textarea>' +
      '<button type="submit" class="dk-chat-send" id="dk-chat-send" aria-label="Senden">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 11l18-8-8 18-2-7-8-3z"></path></svg>' +
      "</button>" +
      "</form>" +
      '<div class="dk-chat-foot__legal">Dr.Kalla · Beratung ohne Gewähr · <a href="/pages/contact">Kontakt</a></div>' +
      "</div>";

    root.appendChild(launcher);
    root.appendChild(panel);

    body = panel.querySelector("#dk-chat-body");
    input = panel.querySelector("#dk-chat-input");
    sendBtn = panel.querySelector("#dk-chat-send");
    shipWrap = panel.querySelector("#dk-ship");
    shipTxt = panel.querySelector("#dk-ship-txt");
    shipFill = panel.querySelector("#dk-ship-fill");
    contextLabel = panel.querySelector('#dk-chat-context-label');
    contextToggle = panel.querySelector('#dk-chat-context');
    contextToggle.checked = contextEnabled;
    contextToggle.addEventListener('change', function() { contextEnabled = contextToggle.checked; updateContext(); saveHistory(); });
    panel.querySelector('.dk-chat-reset').addEventListener('click', function() {
      if(streaming || !window.confirm('Diesen Chat in diesem Tab leeren?')) return;
      messages = []; body.replaceChildren(); saveHistory(); restoreOrGreet(); input.focus();
    });
    body.setAttribute('role','log');
    body.setAttribute('aria-label','Chatverlauf');
    input.setAttribute('aria-label','Ihre Nachricht');
    input.maxLength = MAX_MSG_LEN;
    root.addEventListener('click',function(e) { if(e.target.closest('a[href]')) saveHistory(); });
    window.addEventListener('pagehide',saveHistory);
    window.addEventListener('pageshow',updateContext);

    // Keep the free-shipping bar + header badge in sync with any cart change.
    document.addEventListener("dk:cart-updated", syncCart);

    launcher.addEventListener("click", onLauncherClick);
    panel.querySelector(".dk-chat-header__close").addEventListener("click", close);
    panel.querySelector("#dk-chat-form").addEventListener("submit", onSubmit);
    input.addEventListener("input", autoGrow);
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSubmit(e);
      }
    });

    // Escape affects the companion only while focus is inside it.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && root.classList.contains("dk-open") && root.contains(e.target)) close();
    });
    // This is a non-modal companion: the shop stays keyboard-accessible.

    // Keep the mobile collapsed-tab state in sync when the viewport crosses 600px.
    var mq = window.matchMedia("(max-width: 600px)");
    var onBreak = function (e) {
      if (root.classList.contains("dk-open")) return;
      if (e.matches) root.classList.add("dk-mini");
      else root.classList.remove("dk-mini");
    };
    if (mq.addEventListener) mq.addEventListener("change", onBreak);
    else if (mq.addListener) mq.addListener(onBreak);

    if (isMobile()) root.classList.add("dk-mini");
  }

  function autoGrow() {
    input.style.height = "auto";
    input.style.height = Math.min(input.scrollHeight, 96) + "px";
  }

  // --- open/close ----------------------------------------------------------
  // One tap opens the companion on every viewport.
  function onLauncherClick() {
    toggle();
  }
  function toggle() {
    root.classList.contains("dk-open") ? close() : open();
  }
  function open(restored) {
    root.classList.remove('dk-mini');
    root.classList.add("dk-open");
    launcher.setAttribute("aria-expanded", "true");
    launcher.tabIndex = -1;
    updateContext();
    syncCart();
    if (!greeted) {
      greeted = true;
      restoreOrGreet();
    }
    setTimeout(function () {
      if(!restored) input && input.focus();
      scrollDown();
    }, 60);
    saveHistory();
  }
  function close() {
    root.classList.remove("dk-open");
    launcher.setAttribute("aria-expanded", "false");
    launcher.tabIndex = 0;
    saveHistory();
    // Minimizing keeps the answer running so it is ready when reopened.
    if (isMobile()) root.classList.add("dk-mini");
    // Return focus to the launcher for keyboard users.
    if (launcher) launcher.focus();
  }

  function restoreOrGreet() {
    if (messages.length > 0) {
      messages.forEach(function (m) {
        if(m.content) addBubble(m.role === "assistant" ? "bot" : "user", m.content);
        if(m.products && m.products.length) renderProducts(m.products);
        if(m.links && m.links.length) renderLinks(m.links);
        if(m.pending) appendSystemNote('Die letzte Antwort wurde unterbrochen. Sie können hier weiterfragen.');
      });
      scrollDown();
      return;
    }
    var name = cfg.customerName ? " " + cfg.customerName : "";
    addBubble(
      "bot",
      "Willkommen bei Dr.Kalla" +
        name +
        ". Gern helfe ich Ihnen, das passende Produkt zu finden, und beantworte Fragen zu Versand, Rückgabe und mehr. Womit darf ich helfen?"
    );
    var chips = SUGGESTIONS.map(function (s) {
      return { label: s, value: s };
    });
    // Welcome-voucher entry point — only for guests (logged-in customers can't
    // redeem the first-order code, mirroring the homepage popup logic).
    if (!cfg.customerLoggedIn) {
      chips.unshift({
        label: WELCOME_PCT + " % auf Ihre erste Bestellung",
        value: "__dk_newsletter__",
        cls: "dk-chip--gift",
      });
    }
    if (cfg.whatsapp) {
      chips.push({
        label: "Per WhatsApp schreiben",
        value: "__dk_whatsapp__",
        cls: "dk-chip--wa",
      });
    }
    renderChips(chips);
  }

  // --- conversion: free-shipping bar --------------------------------------
  function setShipPct(p) {
    if (shipFill) shipFill.style.width = Math.max(0, Math.min(100, p)) + "%";
  }
  function renderShipBar(totalCents) {
    if (!shipWrap || !FREE_SHIP) return;
    var remain = FREE_SHIP - totalCents;
    shipWrap.classList.remove("dk-ship--done");
    if (totalCents <= 0) {
      shipTxt.innerHTML =
        "Versandkostenfrei ab <strong>" + formatMoney(FREE_SHIP) + "</strong>";
      setShipPct(4);
    } else if (remain <= 0) {
      shipTxt.innerHTML =
        "<strong>Versandkostenfrei</strong> — Ihr Vorteil ist aktiv.";
      shipWrap.classList.add("dk-ship--done");
      setShipPct(100);
    } else {
      shipTxt.innerHTML =
        "Noch <strong>" +
        formatMoney(remain) +
        "</strong> bis zur versandkostenfreien Lieferung";
      setShipPct(Math.round((totalCents / FREE_SHIP) * 100));
    }
    shipWrap.removeAttribute("hidden");
  }
  // One read of /cart.js drives both the free-shipping bar and the header badge.
  function syncCart() {
    fetch("/cart.js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (c) {
        if (!c) return;
        renderShipBar(c.total_price || 0);
        updateCartBubble(c.item_count || 0);
      })
      .catch(function () {
        /* ignore — UI just stays as-is */
      });
  }

  // --- conversion: WhatsApp handoff ---------------------------------------
  function openWhatsApp() {
    if (!cfg.whatsapp) return;
    var num = String(cfg.whatsapp).replace(/[^0-9]/g, "");
    if (!num) return;
    var text = encodeURIComponent(
      cfg.whatsappText || "Hallo Dr.Kalla, ich habe eine Frage zu …"
    );
    window.open("https://wa.me/" + num + "?text=" + text, "_blank", "noopener");
  }

  // --- conversion: newsletter / welcome voucher ---------------------------
  // CTA bubble shown once when the agent decides to offer (marker [[GUTSCHEIN]]).
  function renderVoucherCta() {
    var row = el("div", "dk-chips");
    var chip = el(
      "button",
      "dk-chip dk-chip--gift",
      WELCOME_PCT + " % Willkommensgutschein sichern"
    );
    chip.addEventListener("click", function () {
      row.remove();
      openNewsletter();
    });
    row.appendChild(chip);
    body.appendChild(row);
    scrollDown();
  }
  function openNewsletter() {
    // Any path into the form counts as "offered" — the agent won't push again.
    markOfferShown();
    var card = el("div", "dk-news");
    card.innerHTML =
      '<div class="dk-news__title">' +
      WELCOME_PCT +
      " % Willkommensgutschein</div>" +
      '<div class="dk-news__sub">Tragen Sie sich für unseren Newsletter ein. Nach der Bestätigung Ihrer E-Mail-Adresse erhalten Sie Ihren persönlichen Gutschein (einmal einlösbar, 30 Tage gültig).</div>' +
      '<form class="dk-news__form" novalidate>' +
      '<input type="email" class="dk-news__email" placeholder="Ihre E-Mail-Adresse" autocomplete="email" required>' +
      '<label class="dk-news__consent"><input type="checkbox" class="dk-news__ok" required> Ja, ich möchte den Dr.Kalla Newsletter mit Produkttipps, Neuheiten, Angeboten und Nachkauf-Erinnerungen passend zu meinen Bestellungen per E-Mail erhalten. Dafür wird ausgewertet, ob ich über einen Link aus einer E-Mail bestelle. Abmelden kann ich mich jederzeit über den Link in jeder E-Mail. Mehr dazu in der <a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutzerklärung</a>.</label>' +
      '<button type="submit" class="dk-news__btn">' +
      WELCOME_PCT +
      "%-Gutschein sichern</button>" +
      '<div class="dk-news__err" hidden></div>' +
      "</form>";
    body.appendChild(card);
    scrollDown();

    var form = card.querySelector(".dk-news__form");
    var emailEl = card.querySelector(".dk-news__email");
    var okEl = card.querySelector(".dk-news__ok");
    var btn = card.querySelector(".dk-news__btn");
    var errEl = card.querySelector(".dk-news__err");
    function showErr(m) {
      errEl.textContent = m;
      errEl.removeAttribute("hidden");
    }
    setTimeout(function () {
      try {
        emailEl.focus();
      } catch (e) {}
    }, 40);

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      errEl.setAttribute("hidden", "");
      var email = (emailEl.value || "").trim();
      if (!email || email.indexOf("@") < 1 || email.indexOf(".") < 0) {
        showErr("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
        return;
      }
      if (!okEl.checked) {
        showErr("Bitte bestätigen Sie kurz die Einwilligung.");
        return;
      }
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = "…";
      var fd = new FormData();
      fd.append("email", email);
      fd.append("offer", "welcome");
      fd.append("source", "chat");
      // Double opt-in: the app stores this exact checkbox wording.
      fd.append("consent", "accepted");
      fd.append("consent_version", "2026-10-01-v2");
      fetch(NEWSLETTER_URL, {
        method: "POST",
        body: fd,
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      })
        .then(function (r) {
          return r.json().catch(function () {
            return { ok: r.ok };
          });
        })
        .then(function (data) {
          if (data && data.ok) {
            card.remove();
            addBubble(
              "bot",
              "Vielen Dank. Wir haben Ihnen eine E-Mail geschickt — bitte bestätigen Sie kurz Ihre Anmeldung, dann ist Ihr **" +
                WELCOME_PCT +
                " %-Gutschein** unterwegs. (Bitte auch den Spam-Ordner prüfen.)"
            );
          } else {
            var code = data && data.error;
            if (code === "invalid_email")
              showErr("Diese E-Mail-Adresse sieht nicht gültig aus. Bitte prüfen Sie sie.");
            else
              showErr(
                "Das hat leider nicht geklappt. Bitte versuchen Sie es später erneut oder schreiben Sie an kontakt@drkalla.com."
              );
            btn.disabled = false;
            btn.textContent = label;
          }
        })
        .catch(function () {
          showErr("Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.");
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  // --- rendering -----------------------------------------------------------
  function addBubble(kind, text) {
    var wrap = el("div", "dk-msg dk-msg--" + (kind === "user" ? "user" : "bot"));
    var bubble = el("div", "dk-msg__bubble", renderText(text));
    wrap.appendChild(bubble);
    body.appendChild(wrap);
    scrollDown();
    return bubble;
  }
  function clearStatus() {
    if (statusEl) {
      statusEl.remove();
      statusEl = null;
    }
  }
  function showStatus(text) {
    clearStatus();
    statusEl = el(
      "div",
      "dk-status",
      escapeHtml(text) +
        ' <span class="dk-status__dots"><span></span><span></span><span></span></span>'
    );
    body.appendChild(statusEl);
    scrollDown();
  }
  function appendText(delta) {
    clearStatus();
    if (!currentBubble) {
      currentBubble = addBubble("bot", "");
      currentBubble._raw = "";
    }
    currentBubble._raw += delta;
    currentBubble.innerHTML = renderText(currentBubble._raw);
    scrollDown();
  }
  function renderProducts(items) {
    clearStatus();
    currentBubble = null;
    var row = el("div", "dk-products");
    items.filter(function(p) { return p && /^\/products\//.test(safeLink(p.url) || ''); }).slice(0,8).forEach(function (p) {
      row.appendChild(productCard(p));
    });
    body.appendChild(row);
    scrollDown();
  }
  function productCard(p) {
    var card = el("div", "dk-prod");
    var media = el("a", "dk-prod__media" + (p.image ? "" : " dk-prod__media--empty"));
    media.href = safeLink(p.url);
    media.setAttribute('aria-label', p.title || 'Produkt ansehen');
    if (safeImage(p.image)) {
      var img = el("img");
      img.src = safeImage(p.image);
      img.alt = p.title || "";
      img.loading = "lazy";
      media.appendChild(img);
    } else {
      media.textContent = "✦";
    }
    card.appendChild(media);

    var bodyEl = el("div", "dk-prod__body");
    var titleLink = el("a", "dk-prod__title", escapeHtml(p.title || ""));
    titleLink.href = safeLink(p.url);
    bodyEl.appendChild(titleLink);

    if (p.profiPriceFormatted) {
      // Pro price highlighted, normal price kept (struck) for reference.
      var profiWrap = el("div", "dk-prod__price");
      profiWrap.innerHTML =
        '<span class="dk-prod__profi">Profi ' +
        escapeHtml(p.profiPriceFormatted) +
        "</span>" +
        (p.priceFormatted ? ' <s>' + escapeHtml(p.priceFormatted) + "</s>" : "");
      bodyEl.appendChild(profiWrap);
    } else if (p.priceFormatted) {
      var price = escapeHtml(p.priceFormatted);
      if (p.compareAtFormatted) price += " <s>" + escapeHtml(p.compareAtFormatted) + "</s>";
      bodyEl.appendChild(el("div", "dk-prod__price", price));
    }

    bodyEl.appendChild(el("div", "dk-prod__spacer"));

    var actions = el("div", "dk-prod__actions");
    var addBtn = el("button", "dk-prod__add");
    if (p.multiVariant) {
      // Several variants (e.g. nuances/sizes) — don't silently add a guessed one;
      // send the customer to the product page to pick the right variant.
      addBtn.textContent = "Variante wählen";
      addBtn.addEventListener("click", function () {
        saveHistory();
        window.location.assign(safeLink(p.url));
      });
    } else if (p.available && p.variantId) {
      addBtn.textContent = "In den Warenkorb";
      addBtn.addEventListener("click", function () {
        addToCart(p, addBtn);
      });
    } else {
      addBtn.textContent = "Nicht verfügbar";
      addBtn.disabled = true;
    }
    if(!p.referenceOnly) actions.appendChild(addBtn);

    var link = el("a", "dk-prod__link", "Produkt ansehen");
    link.href = safeLink(p.url);
    if(p.referenceOnly) bodyEl.appendChild(el('small','dk-prod__reference','Aktueller Preis und Verfügbarkeit beim Produkt.'));
    actions.appendChild(link);

    bodyEl.appendChild(actions);
    card.appendChild(bodyEl);
    return card;
  }
  function renderLinks(items) {
    var row = el('nav','dk-chat-links');
    row.setAttribute('aria-label','Passende Shop-Seiten');
    cleanLinks(items).forEach(function(item) {var a=el('a','dk-chip',escapeHtml(item.label)); a.href=item.url; row.appendChild(a);});
    body.appendChild(row); scrollDown();
  }
  function renderChips(items) {
    var row = el("div", "dk-chips");
    items.forEach(function (it) {
      var chip = el(
        "button",
        "dk-chip" + (it.cls ? " " + it.cls : ""),
        escapeHtml(it.label)
      );
      chip.addEventListener("click", function () {
        // WhatsApp opens externally — keep the chips row so it stays reachable.
        if (it.value === "__dk_whatsapp__") {
          openWhatsApp();
          return;
        }
        row.remove();
        if (it.value === "__dk_newsletter__") {
          openNewsletter();
          return;
        }
        submitText(it.value);
      });
      row.appendChild(chip);
    });
    body.appendChild(row);
    scrollDown();
  }

  // --- add to cart ---------------------------------------------------------
  function addToCart(p, btn) {
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = "…";
    fetch(CART_ADD, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ items: [{ id: Number(p.variantId), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error("cart");
        return r.json();
      })
      .then(function () {
        btn.textContent = "✓ Im Warenkorb";
        btn.classList.add("dk-added");
        // Single source of truth: re-reads /cart.js → ship bar + header bubble.
        try {
          document.dispatchEvent(new CustomEvent("dk:cart-updated"));
        } catch (e) {}
        // Notify Dawn's cart-drawer / count via its pub-sub bus, if present.
        try {
          if (
            typeof publish === "function" &&
            typeof PUB_SUB_EVENTS !== "undefined" &&
            PUB_SUB_EVENTS.cartUpdate
          ) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: "dk-chat" });
          }
        } catch (e) {}
        // In the theme editor cart mutations don't persist — skip the link there.
        try {
          if (window.Shopify && window.Shopify.designMode) return;
        } catch (e) {}
        addCartLink();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
        appendSystemNote("Konnte nicht in den Warenkorb legen. Bitte direkt auf der Produktseite versuchen.");
      });
  }
  // Update the custom header's count badge to match the theme's markup:
  // #cart-icon-bubble > .cart-count-bubble > span[aria-hidden]. The badge is
  // absent entirely when the cart is empty, so we add/remove it as needed.
  function updateCartBubble(count) {
    try {
      var link = document.querySelector("#cart-icon-bubble");
      if (!link) return;
      var bubble = link.querySelector(".cart-count-bubble");
      if (!count || count <= 0) {
        if (bubble) bubble.remove();
        return;
      }
      var shown = count < 100 ? String(count) : "99+";
      if (!bubble) {
        bubble = document.createElement("span");
        bubble.className = "cart-count-bubble";
        bubble.innerHTML = '<span aria-hidden="true"></span>';
        link.appendChild(bubble);
      }
      var inner = bubble.querySelector('span[aria-hidden="true"]') || bubble;
      inner.textContent = shown;
    } catch (e) {
      /* non-fatal — bubble just won't refresh */
    }
  }
  function addCartLink() {
    var row = el("div", "dk-chips");
    var chip = el("a", "dk-chip", "Warenkorb ansehen →");
    chip.href = CART_URL;
    chip.target = "_top";
    chip.style.textDecoration = "none";
    row.appendChild(chip);
    body.appendChild(row);
    scrollDown();
  }
  function appendSystemNote(text) {
    var note = addBubble("bot", text);
    note.style.fontStyle = "italic";
  }

  // --- send / stream -------------------------------------------------------
  function onSubmit(e) {
    if (e && e.preventDefault) e.preventDefault();
    submitText(input.value);
  }
  function submitText(text) {
    text = (text || "").trim().slice(0,MAX_MSG_LEN);
    if (!text || streaming) return;
    input.value = "";
    autoGrow();
    addBubble("user", text);
    messages.push({ role: "user", content: text });
    saveHistory();
    stream();
  }

  function setBusy(on) {
    streaming = on;
    if (sendBtn) sendBtn.disabled = on;
    if (input) input.disabled = on;
  }

  function stream() {
    setBusy(true);
    currentBubble = null;
    showStatus("Einen Moment");
    var assistantText = "";
    var answer = {role:'assistant',content:'',products:[],links:[],pending:true};
    var requestMessages = messages.slice(-12).filter(function(m) {return m.content;}).map(function(m) {return {role:m.role,content:m.content};});
    messages.push(answer);
    saveHistory();
    var ac = typeof AbortController !== "undefined" ? new AbortController() : null;
    currentAbort = ac;

    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "text/event-stream" },
      body: JSON.stringify({
        messages: requestMessages,
        offerVoucher: voucherEligible(),
        pageContext: pageContext(),
      }),
      signal: ac ? ac.signal : undefined,
    })
      .then(function (resp) {
        if (!resp.ok || !resp.body) throw new Error("net");
        var reader = resp.body.getReader();
        var decoder = new TextDecoder();
        var buffer = "";

        function processBlock(block) {
          var line = block.split("\n").find(function (l) {
            return l.indexOf("data:") === 0;
          });
          if (!line) return;
          var payload = line.slice(5).trim();
          if (!payload) return;
          var evt;
          try {
            evt = JSON.parse(payload);
          } catch (e) {
            return;
          }
          handleEvent(evt);
        }

        function pump() {
          return reader.read().then(function (res) {
            if (res.done) {
              // Flush the decoder and process any trailing complete frame.
              buffer += decoder.decode();
              buffer.split("\n\n").forEach(processBlock);
              finish();
              return;
            }
            buffer += decoder.decode(res.value, { stream: true });
            var parts = buffer.split("\n\n");
            buffer = parts.pop();
            parts.forEach(processBlock);
            return pump();
          });
        }

        function handleEvent(evt) {
          if (evt.type === "status") {
            if (!assistantText) showStatus(evt.text || "Einen Moment");
          } else if (evt.type === "products") {
            var products = Array.isArray(evt.items) ? evt.items : [];
            answer.products = references(answer.products.concat(products));
            renderProducts(products);
            saveHistory();
          } else if (evt.type === "links") {
            answer.links = cleanLinks(evt.items);
            renderLinks(answer.links);
            saveHistory();
          } else if (evt.type === "text") {
            assistantText += evt.delta || "";
            answer.content = stripMarkers(assistantText).slice(0,MAX_MSG_LEN);
            appendText(evt.delta || "");
            saveHistory();
          } else if (evt.type === "error") {
            clearStatus();
            var errorText = evt.text || "Es ist ein Fehler aufgetreten.";
            assistantText += '\n' + errorText;
            answer.content = stripMarkers(assistantText).slice(0,MAX_MSG_LEN);
            addBubble("bot", errorText);
            saveHistory();
          } else if (evt.type === "done") {
            // handled in finish()
          }
        }

        function finish() {
          clearStatus();
          var wantsVoucher = /\[\[GUTSCHEIN\]\]/.test(assistantText);
          var clean = stripMarkers(assistantText).trim();
          if (clean) {
            answer.content = clean.slice(0,MAX_MSG_LEN);
          }
          answer.pending = false;
          saveHistory();
          // Agent chose to offer the voucher — render the CTA once per session.
          if (wantsVoucher && voucherEligible()) {
            markOfferShown();
            renderVoucherCta();
          }
          currentAbort = null;
          setBusy(false);
          // Do not pull focus away from a product or the surrounding shop.
        }

        return pump();
      })
      .catch(function (err) {
        currentAbort = null;
        // Aborted on close — silent.
        if (err && err.name === "AbortError") {
          saveHistory();
          clearStatus();
          setBusy(false);
          return;
        }
        clearStatus();
        answer.pending = false;
        answer.content = 'Die Verbindung wurde unterbrochen. Bitte versuchen Sie es erneut.';
        saveHistory();
        addBubble(
          "bot",
          "Entschuldigung, die Verbindung hat nicht geklappt. Bitte versuchen Sie es erneut oder schreiben Sie an kontakt@drkalla.com."
        );
        setBusy(false);
      });
  }

  // --- init ----------------------------------------------------------------
  function init() {
    if (document.getElementById("dk-chat-launcher-ready")) return;
    build();
    var flag = el("span");
    flag.id = "dk-chat-launcher-ready";
    flag.hidden = true;
    root.appendChild(flag);
    if(session.open === true) open(true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
